// extracted by mini-css-extract-plugin
export default {"wrapper":"PersonInfo_wrapper__pZMnx","list__container":"PersonInfo_list__container__d8B3r","list__item":"PersonInfo_list__item__g1Z9z","item__title":"PersonInfo_item__title__H6cuH"};